import { useMutation, useQueryClient } from '@tanstack/react-query';

export interface DeleteCandidateMailTemplateRequest {
  id: number;
}

export default function useDeleteCandidateMailTemplate() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement)?.content ?? '';
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['candidateMailTemplates'] }),
    mutationFn: async (params: DeleteCandidateMailTemplateRequest): Promise<void> => {
      const response = await fetch(`/agent/api/candidate_mail_templates/${params.id}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete candidate mail template');
      }
    },
  });
}
